import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Container from "../components/Container";
import Meta from "../components/Meta";

const ShippingPolicy = () => {
  return (
    <>
      <Meta title={"Shipping Policy"} />
      <BreadCrumb title="Shipping Policy" />
      <Container class1="policy-wrapper py-5 home-wrapper-2">
        <div className="row">
          <div className="col-12">
            <div className="policy">
              <h2>Shipping Policy</h2>
              <p>
                At <strong>Softech</strong>, we are committed to delivering your products in a timely 
                and efficient manner. Please read our shipping policy to understand how we process 
                and handle shipping.
              </p>

              <h3>1. Processing Time</h3>
              <ul>
                <li>Orders are processed within <strong>1–2 business days</strong>.</li>
                <li>Orders placed after 4:00 PM will be processed the next business day.</li>
                <li>Orders are not processed on weekends or holidays.</li>
              </ul>

              <h3>2. Shipping Methods and Delivery Time</h3>
              <ul>
                <li><strong>Standard Shipping:</strong> 5–7 business days</li>
                <li><strong>Express Shipping:</strong> 2–3 business days</li>
              </ul>

              <h3>3. Shipping Charges</h3>
              <p>
                Shipping charges are calculated at checkout based on the destination and shipping 
                method selected.
              </p>

              <h3>4. International Shipping</h3>
              <p>
                Currently, we only ship within India. International shipping options will be 
                added soon—stay tuned!
              </p>

              <h3>5. Order Tracking</h3>
              <p>
                Once your order has shipped, you will receive a confirmation email with a 
                tracking number. You can track your order using the link provided.
              </p>

              <h3>6. Delayed or Lost Packages</h3>
              <p>
                If your order is delayed or lost during transit, please contact our customer support 
                at <a href="mailto:softechmathikere@gmail.com">softechmathikere@gmail.com</a> 
                with your order number.
              </p>

              <h3>7. Contact Us</h3>
              <p>
                If you have any questions about our shipping policy, feel free to contact us at:  
                <a href="mailto:softechmathikere@gmail.com">softechmathikere@gmail.com</a>
              </p>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default ShippingPolicy;
